import React from 'react';

interface StoryModalProps {
    onClose: () => void;
}

const StoryModal: React.FC<StoryModalProps> = ({ onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-funky-blue p-8 rounded-lg max-w-2xl border-4 border-funky-yellow text-center">
                <h2 className="text-4xl font-funky mb-4 text-funky-pink">The Story</h2>
                <p className="text-funky-yellow mb-4 text-lg">
                    In a digital bamboo forest on the SUI, Disco Panda was born—coding by day, groovin' by night! Tired of boring crypto, he created $PANDA, the grooviest meme coin that makes every transaction a dance party. With lightning-fast moves thanks to SUI, $PANDA zooms through wallets, leaving glitter and funky beats behind. Forget the moon—Disco Panda’s taking you to the dance floor. Buy $PANDA, and let’s boogie! 🕺🐼💰
                </p>
                <button
                    className="px-6 py-3 bg-funky-green text-funky-blue rounded-full hover:bg-funky-yellow hover:text-funky-pink transition-all duration-300 font-bold text-xl"
                    onClick={onClose}
                >
                    Groove On!
                </button>
            </div>
        </div>
    );
};

export default StoryModal;